(function() {

    'use strict';

    eclipseApp.controller('prepaidRefillOneTimeInteracCtrl', ['$scope', '$rootScope', '$state', '$http', '$timeout', '$stateParams', '$previousState', '$sessionStorage', 'uteModal', 'uteLocale', 'httpService', 'retrievePrepaidPlanInfo', 'retrievePrepaidUserInfo', 'prepaidCommonService', 'prepaidAutoRefillInfoService', 'prepaidPlanInfoService', 'prepaidUserInfoService', 'prepaidRefillOneTimeService', 'prepaidRegisteredCCInfoService', 'prepaidRefillTaxCalculationService', 'prepaidAirtimeBalanceService', 'uteSemafoneService', 'util', function($scope, $rootScope, $state, $http, $timeout, $stateParams, $previousState, $sessionStorage, uteModal, uteLocale, httpService, retrievePrepaidPlanInfo, retrievePrepaidUserInfo, prepaidCommonService, prepaidAutoRefillInfoService, prepaidPlanInfoService, prepaidUserInfoService, prepaidRefillOneTimeService, prepaidRegisteredCCInfoService, prepaidRefillTaxCalculationService, prepaidAirtimeBalanceService, uteSemafoneService, util) {

        console.log('Inside prepaidRefillOneTimeInteracCtrl');

        $scope.$extend({

            isOneTimeRefillReview: true,
            stopAutoPaymentNotifier: '',
            autoRefillSubscribed: 'false',
            selectedRefillAmount: null,
            $storage : $sessionStorage,
            language : uteLocale.language,
            refillAmount : '',
            totalAmount : '',
            GSTHSTAmount : '',
            PSTQSTAmount : '',
            InteracResponse : $stateParams.response,
            InteracEligibilityInfo : null,
            InteraPaymentInfo : null,
            refillAmountList : null,
            calculateTaxInfo : null,
            creditPaymentInfo : null,
            planAndAddOnInfo : null,
            InteracEligibilityError : null,
            InteracPaymentError : null,
            refillAmountListError : null,
            calculateTaxInfoError : null,
            creditPaymentInfoError : null,
            planAndAddOnInfoError : null,
            MERCHANT_NUMBER : null,
            IDEBIT_MERCHDATA : null,
            IDEBIT_INVOICE : null,
            IDEBIT_TERMID : null,
            INTERAC_SUCCESS_URL : null,
            INTERAC_FAILURE_URL : null,
            IDEBIT_AMOUNT : null,
            IDEBIT_MERCHLANG : null,
            planTitle : '',
            planFeatures : '',
            ctn : '',
            haveRegisteredCard : false,
            billingAddress : null,
            name : '',
            expiryDate : '',
            cardNumber : '',
            billingType: '',
            accountNumber: prepaidUserInfoService.getBAN(),
            airtimeBalance : prepaidAirtimeBalanceService.getAirTimeBalance(),
            balanceExpiryDate : prepaidAirtimeBalanceService.getExpiryDate(),

            redirectToInteracErrorPage: function() {
                $scope.interacPaymentError = true;
            },

            clearSharedPropertyService: function() {
                prepaidRefillOneTimeService.setRefillValue(null);
                prepaidRefillOneTimeService.setInteracParameters(null);
                prepaidRefillOneTimeService.setBillingType(null);
            },

           getPlanAndAddOnInfo : function (accountNumber, subscriberNumber, language) {
             var promise = httpService.send(
               'v1/wireless/prepaid/dashboard/plan', // TODO : Need to change
               {
               accountNumber: accountNumber,
               ctn: subscriberNumber,
               language: language
               });

             promise.then(
               function (result) {
                 if (result.data.error || result.data.status == 'Failed') {
                   $scope.planAndAddOnInfoError = true;
                 } else {
                   //alert('Got PlanAndAddOnInfo Successfully');
                   $scope.planAndAddOnInfo = result.data;
                   console.log('$scope.planAndAddOnInfo :: '+$scope.planAndAddOnInfo);
                   prepaidAirtimeBalanceService.setAirTimeBalance($scope.planAndAddOnInfo.airtimeBalance);
                   prepaidAirtimeBalanceService.setExpiryDate($scope.planAndAddOnInfo.expiryDate);
                   prepaidPlanInfoService.setAirTimePlanFee($scope.planAndAddOnInfo.pricePlan);
                   $scope.pricePlanInfo = null;
                   if(result.data.planDetailsInfo != null){
                     if($scope.language === 'en' || $scope.language === 'EN'){
                       $scope.pricePlanInfo = result.data.planDetailsInfo.en;
                     }else{
                       $scope.pricePlanInfo = result.data.planDetailsInfo.fr;
                     }
                     if(result.data.planDetailsInfo.productId != null && result.data.planDetailsInfo.productId != ''){
                       prepaidPlanInfoService.setAirTimePlanSoc(result.data.planDetailsInfo.productId);
                     }else{
                       prepaidPlanInfoService.setAirTimePlanSoc($scope.planAndAddOnInfo.planSoc);
                     }
                     if($scope.pricePlanInfo != null && $scope.pricePlanInfo.planComparison != null && $scope.pricePlanInfo.planComparison.planTitle != null && $scope.pricePlanInfo.planComparison.planTitle != ''){
                       prepaidPlanInfoService.setAirTimePlanTitle($scope.pricePlanInfo.planComparison.planTitle);
                     }else{
                       if($scope.language === 'en' || $scope.language === 'EN'){
                         prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.description);
                       }else{
                         prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.descriptionFr);
                       }
                     }
                   }else{
                     if($scope.language === 'en' || $scope.language === 'EN'){
                       prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.description);
                     }else{
                       prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.descriptionFr);
                     }
                     prepaidPlanInfoService.setAirTimePlanSoc($scope.planAndAddOnInfo.planSoc);
                   }
                   $scope.planDesc = prepaidPlanInfoService.getAirTimePlanTitle();
                   prepaidPlanInfoService.setAirTimePlanFeatures($scope.pricePlanInfo);
                   $scope.isOneTimeRefillReview = false;
                   $scope.airtimeBalance = prepaidAirtimeBalanceService.getAirTimeBalance();
                   $scope.balanceExpiryDate = prepaidAirtimeBalanceService.getExpiryDate();
                   $scope.clearSharedPropertyService();
                 }
               },
               function (reason) {
                 $scope.planAndAddOnInfoError = true;
               }
             );
           },

            backToDashboard : function () {
              $scope.clearSharedPropertyService();
              $state.go('myAccount.prepaidWLDashboard' , {'accountNumber': prepaidUserInfoService.getBAN(), 'subscriberNo': prepaidUserInfoService.getCTN()});
            },

            retrieveCreditCardRegistrationInfo : function () {
              var promise = httpService.send(
                'v1/wireless/prepaid/creditcard/retrieve/ccinfo', // TODO : Need to change
                {
                accountNumber: prepaidUserInfoService.getBAN(),
                ctn: prepaidUserInfoService.getCTN()
                });

              promise.then(
                function (result) {
                  if (result.data.error || result.data.status == 'Failed') {
                    $scope.creditCardRegistrationInfoError = true;
                  } else {
                    //alert('Got userInfo Successfully');
                    $scope.creditCardRegistrationInfo = result.data;
                    if($scope.creditCardRegistrationInfo.registrationStatus){
                      //prepaidRegisteredCCInfoService.setCardScheme($scope.creditCardRegistrationInfo.creditCardInfo.cardType);
                      prepaidRegisteredCCInfoService.setTokenizedCCNumber($scope.creditCardRegistrationInfo.creditCardInfo.creditCardNo);
                      prepaidRegisteredCCInfoService.setMonth($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                      prepaidRegisteredCCInfoService.setYear($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                    }
                    prepaidRegisteredCCInfoService.setCreditCardRegistrationStatus($scope.creditCardRegistrationInfo.registrationStatus);
                  }
                },
                function (reason) {
                  $scope.creditCardRegistrationInfoError = true;
                }
              );
            },

            redirectToInteracGateway: function() {
                //alert('redirectToInteracGateway');
                //$('#formToRogers123').attr('action', 'https://merchant-test.interacidebit.ca/gateway/merchant_test_processor.do');
                $scope.$storage.selectedRefillAmount = prepaidRefillOneTimeService.getRefillValue();
                $('#uteInteracForm').attr('action', prepaidRefillOneTimeService.getInteracParameters().INTERAC_URL); // jshint ignore:line
                $timeout(function() {
                    $('#uteInteracForm').submit();
                });
            },

            init: function() {
                //alert('$storage.selectedCTN :: '+$scope.$storage.selectedCTN);
                //alert('$scope.$storage.selectedRefillAmount :: '+$scope.$storage.selectedRefillAmount);
                prepaidRefillOneTimeService.setRefillValue($scope.$storage.selectedRefillAmount);
                prepaidUserInfoService.setCTN($scope.$storage.selectedCTN);
                prepaidUserInfoService.setBAN($scope.$storage.selectedBAN);
                $scope.ctn = prepaidUserInfoService.getCTN();
                $scope.selectedRefillAmount = prepaidRefillOneTimeService.getRefillValue();
                prepaidRefillOneTimeService.setBillingType('Interac');
                if(prepaidRefillTaxCalculationService.getRefillAmount() != '' && prepaidRefillTaxCalculationService.getRefillAmount() != null){
                    //alert('Inside If loop');
                    $scope.refillAmount = prepaidRefillTaxCalculationService.getRefillAmount();
                    $scope.totalAmount = prepaidRefillTaxCalculationService.getTotal();
                    $scope.GSTHSTAmount = prepaidRefillTaxCalculationService.getGST();
                    $scope.PSTQSTAmount = prepaidRefillTaxCalculationService.getPST();
                    $scope.refillValue = prepaidRefillOneTimeService.getRefillValue();
                }else{
                    //alert('Inside else part');
                    prepaidRefillOneTimeService.setBillingType('Interac');
                    var promise = httpService.send(
                        'v1/refill/interac/payment/eligibility/check', // TODO : Need to change
                        {
                            accountNumber: prepaidUserInfoService.getBAN(),
                            ctn: prepaidUserInfoService.getCTN(),
                            refillAmount: prepaidRefillOneTimeService.getRefillValue().rechargeAmount,
                            language: $scope.language
                        });

                    promise.then(
                        function(result) {
                            if (result.data.error || result.data.status == 'Failed') {
                                $scope.InteracEligibilityError = true;
                            } else {
                                //alert('Got AutoRefillEligibility Successfully');
                                $scope.InteracEligibilityInfo = result.data;
                                prepaidRefillOneTimeService.setInteracParameters($scope.InteracEligibilityInfo.interacParameters);
                                prepaidRefillTaxCalculationService.setRefillAmount($scope.InteracEligibilityInfo.refillAmount);
                                prepaidRefillTaxCalculationService.setTotal($scope.InteracEligibilityInfo.total);
                                prepaidRefillTaxCalculationService.setGST($scope.InteracEligibilityInfo.gsthst);
                                prepaidRefillTaxCalculationService.setHST($scope.InteracEligibilityInfo.gsthst);
                                prepaidRefillTaxCalculationService.setPST($scope.InteracEligibilityInfo.pstqst);
                                prepaidRefillTaxCalculationService.setQST($scope.InteracEligibilityInfo.pstqst);
                                if (prepaidRefillOneTimeService.getInteracParameters() != '' && prepaidRefillOneTimeService.getInteracParameters() != null) {
                                    //alert('Inside Interac Parameters');
                                    $scope.MERCHANT_NUMBER = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_MERCHNUM;
                                    $scope.IDEBIT_MERCHDATA = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_MERCHDATA;
                                    $scope.IDEBIT_INVOICE = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_INVOICE;
                                    $scope.IDEBIT_TERMID = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_TERMID;
                                    $scope.INTERAC_SUCCESS_URL = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_FUNDEDURL;
                                    $scope.INTERAC_FAILURE_URL = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_NOTFUNDEDURL;
                                    $scope.IDEBIT_MERCHLANG = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_MERCHLANG;
                                    $scope.IDEBIT_AMOUNT = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_AMOUNT;
                                }
                                if(prepaidRefillTaxCalculationService.getRefillAmount() != '' && prepaidRefillTaxCalculationService.getRefillAmount() != null){
                                  $scope.refillAmount = prepaidRefillTaxCalculationService.getRefillAmount();
                                  $scope.totalAmount = prepaidRefillTaxCalculationService.getTotal();
                                  $scope.GSTHSTAmount = prepaidRefillTaxCalculationService.getGST();
                                  $scope.PSTQSTAmount = prepaidRefillTaxCalculationService.getPST();
                                }

                                if(prepaidRefillOneTimeService.getRefillValue() != '' && prepaidRefillOneTimeService.getRefillValue() != null){
                                  $scope.refillValue = prepaidRefillOneTimeService.getRefillValue();
                                }
                            }
                        },
                        function(reason) {
                            $scope.InteracEligibilityError = true;
                        }
                    );
                }

                if($scope.InteracResponse === 'funded'){
                  $scope.isOneTimeRefillReview = false;
                  //$scope.clearSharedPropertyService();
                  $scope.getPlanAndAddOnInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), $scope.language);
                } else if($scope.InteracResponse === 'notFunded'){
                  $scope.redirectToInteracErrorPage();
                }
                $scope.planTitle = prepaidPlanInfoService.getAirTimePlanTitle();
                $scope.planFeatures = prepaidPlanInfoService.getAirTimePlanFeatures();
                $scope.ctn = prepaidUserInfoService.getCTN();
                $scope.haveRegisteredCard = prepaidRegisteredCCInfoService.getCreditCardRegistrationStatus();
                $scope.billingAddress = prepaidUserInfoService.getBillingAddress();
                $scope.name = prepaidUserInfoService.getFirstName() + ' ' + prepaidUserInfoService.getLastName();
                if ($scope.haveRegisteredCard) {
                    $scope.expiryDate = prepaidRegisteredCCInfoService.getMonth();
                    $scope.cardNumber = prepaidRegisteredCCInfoService.getTokenizedCCNumber();
                }
            }
        });

        $scope.init();

    }]);

})();
